//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../GeometricUtilities/GeometricUtilities.CurveLengthBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../GeometricUtilities/GeometricUtilities.ProjectionOptions.js";
import "../no/Section.js";
import "../no/GeometricUtilities.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[0,"AlignRefType0",1,0],[0,"AlignRefType1",1,0],[1,"BooleanOperation",0,"GeometricUtilities.BooleanOperation",0],[1,"CurveLength",0,"GeometricUtilities.CurveLengthBuilder",0],[1,"GuideFaces",0,"ScCollector",0],[0,"GuideObjectType",1,0],[0,"IsLimit1MeasureExpressionUsed",1,0],[0,"IsLimit2MeasureExpressionUsed",1,0],[1,"Limit1Offset",0,"Expression",0],[1,"Limit1Point",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"Limit1Selection",0,"ScCollector",0],[0,"Limit1Type",1,0],[1,"Limit2Offset",0,"Expression",0],[1,"Limit2Point",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"Limit2Selection",0,"ScCollector",0],[0,"Limit2Type",1,0],[0,"Plane",1,"Plane",0],[1,"ProjectDirection",0,"GeometricUtilities.ProjectionOptions",0],[0,"ReverseLimit1OffsetDirection",1,0],[0,"ReverseLimit2OffsetDirection",1,0],[0,"ReverseThicknessDirection",1,0],[0,"ReverseThicknessOffsetDirection",1,0],[0,"ReverseWidth1Direction",1,0],[0,"ReverseWidth2Direction",1,0],[0,"ReverseWidthOffsetDirection",1,0],[1,"Section",0,"Section",0],[1,"SkinFaceCollector",0,"ScCollector",0],[1,"Thickness",0,"Expression",0],[0,"ThicknessDimensionType",1,0],[1,"ThicknessOffset",0,"Expression",0],[1,"Width1",0,"Expression",0],[1,"Width2",0,"Expression",0],[0,"WidthDimensionType",1,0],[0,"WidthMethod",1,0],[1,"WidthOffset",0,"Expression",0]],[[["deleteGuideCurves","showGuideCurves"],"ConstructGuidecurves",{},2,0]],[]];
SPLM.Features.AeroFlangeBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AeroFlangeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.AeroFlangeBuilder.GuideObjectTypes = Object.freeze({
    "Face" : "Face", "DatumPlane" : "DatumPlane", "Curve" : "Curve"});

SPLM.Features.AeroFlangeBuilder.ThicknessDimensionOptions = Object.freeze({
    "Simple" : "Simple", "Symmetric" : "Symmetric"});

SPLM.Features.AeroFlangeBuilder.WidthMethods = Object.freeze({
    "OffsetGuideFace" : "OffsetGuideFace", "OffsetGuideCurveAlongSkin" : "OffsetGuideCurveAlongSkin"});

SPLM.Features.AeroFlangeBuilder.WidthDimensionOptions = Object.freeze({
    "Simple" : "Simple", "Symmetric" : "Symmetric", "Asymmetric" : "Asymmetric"});

SPLM.Features.AeroFlangeBuilder.LimitObjectTypes = Object.freeze({
    "FromGuideCurve" : "FromGuideCurve", "FromSelected" : "FromSelected"});

SPLM.Features.AeroFlangeBuilder.PointOption = Object.freeze({
    "ArcLength" : "ArcLength", "PercentArcLength" : "PercentArcLength", "ParameterArcLength" : "ParameterArcLength", "ThroughPoint" : "ThroughPoint"});

SPLM.Features.AeroFlangeBuilder.AlignReferenceType = Object.freeze({
    "None" : "None", "LengthFace" : "LengthFace", "Skin" : "Skin", "GuideFace" : "GuideFace"});

export default SPLM;